import { removeMdnFormatting } from "@expert/common-ui";
import { useMemo } from "react";

import { useTypedMostRecentTask } from "@/sdk";

interface UseTaskMdnProps {
    blocklistedNumbers?: string[];
    blocklistedPrefixes?: string[];
}

const isBlocklisted = (mdn: string, blocklistedNumbers?: string[], blocklistedPrefixes?: string[]) => {
    if (!blocklistedNumbers && !blocklistedPrefixes) return false;
    if (blocklistedNumbers?.includes(mdn)) return true;
    if (blocklistedPrefixes?.some((prefix) => mdn.startsWith(prefix))) return true;
};

export const useTaskMdn = ({ blocklistedNumbers, blocklistedPrefixes }: UseTaskMdnProps) => {
    const { isVoice, isChat, voiceTask, chatTask } = useTypedMostRecentTask();

    const taskMdn = useMemo(() => {
        let mdn = "";

        if (isVoice && voiceTask) {
            mdn = voiceTask.mdn ?? "";
        } else if (isChat && chatTask) {
            // The chat task's mdn comes in formatted with the mask used in the chat UI, so we need to remove that formatting
            const unformattedMdn = removeMdnFormatting(chatTask.mdn.value ?? "");

            mdn = unformattedMdn.length === 10 ? `+1${unformattedMdn}` : unformattedMdn;
        }

        return isBlocklisted(mdn, blocklistedNumbers, blocklistedPrefixes) ? "" : mdn;
    }, [isVoice, isChat, voiceTask, chatTask, blocklistedNumbers, blocklistedPrefixes]);

    return taskMdn;
};
